<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Customer Details</h4>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <ng-container *ngIf="customerType == this.customerTypes.Individual.id">
        <individual-customer [customerNumber]="customerNumberId" [inModal]="true"></individual-customer>
    </ng-container>
    <ng-container *ngIf="customerType == this.customerTypes.Organization.id">
        <organization-customer [customerNumber]="customerNumberId" [inModal]="true"></organization-customer>
    </ng-container>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button type="button" class="btn--default" (click)="cancel()">Close</button>
    </div>
</div>
